import { render, staticRenderFns } from "./ConfirmPhoneAlert.vue?vue&type=template&id=aad5c5bc&"
import script from "./ConfirmPhoneAlert.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneAlert.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPhoneAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports